import type { CentrumPodpowiedz } from '@/lib/employees-api';

/**
 * DOPASOWANIE PODPOWIEDZI CENTRUM KOSZTOWEGO.
 *
 * ══════════════════════════════════════════════════════════════════════════════════════════════
 *  ⚠️⚠️ ZGŁOSZONE 01.09.2026: „w edycji pracownika pole Centrum kosztowe miało podpowiadać rzeczy
 *  które są w centrach kosztowych — teraz jest to zwykłe pole tekstowe i nie podpowiada".
 *  Podpowiedzi BYŁY, ale wisiały na `<datalist>`, a ten w Chrome i Edge nie rozwija się przy
 *  `autocomplete="off"` — czyli dokładnie tam, gdzie stał. Pole wyglądało więc na goły tekst.
 *  Lista rysowana przez nas nie zależy od tego, co przeglądarka zrobi z podpowiedziami.
 * ══════════════════════════════════════════════════════════════════════════════════════════════
 */

/** Ile pozycji pokazujemy naraz — resztę odsiewa wpisywanie, a lista ma się dać przejrzeć. */
export const LIMIT_PODPOWIEDZI = 20;

/**
 * ⚠️ TRAFIENIA OD POCZĄTKU KODU IDĄ PIERWSZE. Kody centrów u klientów mają wspólne przedrostki
 * (`M1PRAPKO`, `M9MEBPKO`), więc przy wpisanym „M1" podpowiedź zawierająca „M1" w środku innego
 * kodu spychałaby to, czego człowiek właśnie szuka, poniżej krawędzi listy.
 *
 * ⚠️ WEWNĄTRZ GRUPY ZOSTAJE KOLEJNOŚĆ Z SERWERA (najczęściej używane u ludzi na górze) — to ona
 * podpowiada, który wariant pisowni jest w tej firmie właściwy.
 */
export function filtrujCentra(lista: CentrumPodpowiedz[], wpisane: string): CentrumPodpowiedz[] {
  const igla = wpisane.trim().toLowerCase();
  if (igla === '') return lista.slice(0, LIMIT_PODPOWIEDZI);

  const odPoczatku: CentrumPodpowiedz[] = [];
  const wSrodku: CentrumPodpowiedz[] = [];
  for (const c of lista) {
    const kod = c.code.toLowerCase();
    if (kod.startsWith(igla)) odPoczatku.push(c);
    else if (kod.includes(igla)) wSrodku.push(c);
  }
  return [...odPoczatku, ...wSrodku].slice(0, LIMIT_PODPOWIEDZI);
}
